<template>
  <div style="line-height:0.7;min-height:29px;" :style="{ '-w': inputWidth}">
    <el-select
      ref="vueSelect"
      v-model="selectedValue"
      :multiple="multiple"
      :filterable="filterable"
      :remote="remote"
      :clearable="clearable"
      :placeholder="placeholder"
      :collapse-tags="collapse"
      :filter-method="filterMethod"
      :popper-class="!paging ? 'select-page' : 'select-page select-page-padding'"
      :style="{ '--width': inputWidth + 'px'}"
      class="vue-select-page"
      :reserve-keyword="true"
      :disabled="selectDisabled"
      @change="handleChange"
      @visible-change="handleVisibleChange"
      @remove-tag="onRemoveTag"
      @clear="onClear"
      @blur="onBlur"
      @focus="onFocus"
    >
      <div>
        <el-option
          v-for="item in curOptions"
          :key="item[valueKey]"
          :label="returnItemLabel(item)"
          :value="item[valueKey]"
          :disabled="item[disabledKey]"
        />
      </div>
      <div v-show="paging" class="select-pagination">
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="total"
          small
          layout="total, prev, slot, next, jumper"
          @current-change="handleCurrentChange"
        >
          <span>{{ currentPage }} / {{ Math.ceil(total / pageSize) }}</span>
        </el-pagination>
      </div>
    </el-select>
  </div>
</template>
<script>
export default {
  // model: {
  //   prop: 'value',
  //   event: 'input'
  // },
  props: {
    value: {
      type: String | Number | Array | Function, // eslint-disable-line
      default: () => ''
    },
    filterable: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    options: {
      type: Array,
      default: () => []
    },
    labelKey: { // 支持label，或者{label}格式，若需要自定义展示的内容，则需按照{label}的格式，例如：({id}) {name}
      type: String,
      default: () => 'label'
    },
    valueKey: {
      type: String,
      default: () => 'value'
    },
    disabledKey: {
      type: String,
      default: () => 'disabled'
    },
    selectDisabled: {
      type: Boolean,
      default: () => false
    },
    paging: {
      type: Boolean,
      default: () => true
    },
    collapse: {
      type: Boolean,
      default: () => false
    },
    detailsPage: { // 是否详情页回显
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      startFilter: false,
      remote: false,
      filterVal: '',
      curOptions: [],
      filterOptions: [],
      currentPage: 1,
      pageSize: 30,
      total: 1000,
      inputWidth: 400
    }
  },
  computed: {
    selectedValue: {
      get: function() {
        // this.handleChange(this.value)
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    options(newV) {
      if (this.detailsPage && !this.multiple) {
        this.detailsPageHandleOptions(newV)
      } else {
        this.caculateCurOptions(newV)
      }
    },
    value(newV) {
      if (this.detailsPage && !this.multiple) {
        this.detailsPageHandleOptions(this.options)
      } else {
        this.initOptions()
      }
    }
  },
  created() {
    if (this.detailsPage && !this.multiple) {
      this.detailsPageHandleOptions(this.options, 'init')
    } else {
      this.initOptions()
    }
  },
  mounted() {
    // let inputWidth = this.$refs.vueSelect.$el.getBoundingClientRect().width
    // this.inputWidth = inputWidth
    // console.log(inputWidth)
  },
  methods: {
    handleCurrentChange(cur) {
      this.caculateCurOptions(this.startFilter ? this.filterOptions : this.options)
    },
    handleChange(val) {
      this.remote = false
      this.$emit('input', val)
      this.$emit('change', val)
      if (val.length > 0) {
        if (this.collapse) {
          this.startFilter = false
          const firstValue = this.options.filter(e => e[this.valueKey] === val[0])[0]
          this.$nextTick(() => {
            if (firstValue) {
              // 手动给select框中的tag赋值，解决切换页时，select框中数据不能正确展示label的问题
              this.$refs.vueSelect.$children[2].$el.children[0].innerText = this.returnItemLabel(firstValue)
            }
          })
        }
      }
    },
    filterMethod(val) {
      this.filterVal = val
      this.remote = true
      this.curOptions = []
      this.currentPage = 1
      if (val === '') {
        // 手动清除输入的文本至空时，需要重置当前筛选的内容
        this.remote = false
        this.startFilter = false
        this.caculateCurOptions(this.options)
        return
      }
      this.startFilter = true
      this.filterOptions = this.options.filter(e => this.returnItemLabel(e).toLowerCase().indexOf(val.trim().toLowerCase()) > -1)
      this.caculateCurOptions(this.filterOptions)
    },
    detailsPageHandleOptions(options, type) {
      this.total = options.length
      if (options.length === 0) {
        // eslint-disable-next-line
        return
      }
      let pageNums = Math.ceil(this.total / this.pageSize) // 多少页
      for (let item = 1; item <= pageNums; item++) {
        let curOptions = this.options.slice(this.pageSize * (item - 1), this.pageSize * item)
        let filterArr = curOptions.filter(f => f[this.valueKey] === this.selectedValue)
        if (filterArr.length > 0) {
          this.currentPage = item
          this.curOptions = curOptions
          if (type === 'init') return
          const curTag = this.$refs.vueSelect.$children[0].$el.children[0] // 当前元素
          // curTag.value = filterArr[0][this.labelKey]
          curTag.value = this.returnItemLabel(filterArr[0])
        }
      }
    },
    // 动态切换当前选项列表中的数据
    caculateCurOptions(options) {
      if (!this.paging) this.curOptions = [...options]
      else this.curOptions = options.filter((e, i) => i >= (this.currentPage - 1) * this.pageSize && i < this.currentPage * this.pageSize)
      this.total = options.length
      if (!this.collapse) {
        this.$nextTick(() => {
          if (Array.isArray(this.selectedValue)) {
            this.selectedValue.forEach((e, i) => {
              const curTag = this.$refs.vueSelect.$children[0].$children[i].$el.children[0]
              curTag.innerText = this.returnItemLabel(this.options.filter(f => f[this.valueKey] === e)[0])
            })
          }
        })
      }
    },
    // 根据传的labelKey，动态拼接label
    returnItemLabel(item) {
      // '({partyId}) {chineseName|name}' (partyId)中文名 找不到中文名则使用英文名
      const tmpArr = this.labelKey.replace(/[\{\}]/g, ',').split(',')
      // '({partyId}) {chineseName|name}' 转换为 ['(', 'partyId', ') ', 'chineseName|name', '']
      let str = ''
      for (let i = 0; i < tmpArr.length; i++) {
        let tmp = tmpArr[i]
        if (!tmp) continue
        if (tmp.includes('|')) {
          let arr = tmp.split('|')
          for (let j = 0; j < arr.length; j++) {
            if (item[arr[j]]) {
              str += item[arr[j]]
              break
            }
          }
        } else {
          str += item[tmp] || tmp
        }
      }
      // tmpArr.forEach(e => {
      //   if (item[e]) str += item[e]
      //   else str += e
      // })
      return str
    },
    handleVisibleChange(visible) {
      if (!visible) {
        if (this.multiple) this.currentPage = 1
        this.startFilter = false
        this.filterVal = ''
        this.blur()
      } else {
        this.focus()
      }
      this.$emit('visible-change', visible)
    },
    onRemoveTag(tag) {
      this.$emit('remove-tag', tag)
    },
    onClear() {
      this.$emit('clear')
    },
    onBlur(e) {
      this.$emit('blur', e)
    },
    onFocus(e) {
      this.$emit('focus', e)
      this.initOptions()
      if (!this.$refs.vueSelect.$refs.input) return
      this.$refs.vueSelect.$refs.input.blur = () => {
        console.log('失去了焦点')
        this.$emit('blur')
        this.filterVal = ''
      }
    },
    focus() {
      this.$refs.vueSelect.focus()
    },
    blur() {
      this.$refs.vueSelect.blur()
    },
    initOptions() {
      if (this.filterVal) {
        return
      }
      let options = this.options
      // 单选，且选中某个值
      // if (!this.multiple && this.selectedValue) {
      //   this.currentPage = 1
      //   options = this.options.filter(e => e[this.valueKey] === this.selectedValue)
      // }
      this.caculateCurOptions(options)
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep {
  .vue-select-page {
    .el-select__tags {
      top: 50%;
      max-height: 56px;
      overflow-y: auto;
      overflow-x: hidden;
      .el-tag--info {
        height: auto;
        max-width: 100%;
        display: inline-block;
        position: relative;
        .el-select__tags-text {
          // max-width: 99%;
          line-height: 1;
          display: inline-block;
          overflow: hidden;
          white-space: normal;
          margin-top: 4px;
        }
        .el-tag__close.el-icon-close {
          right: -3px;
          position: absolute;
          top: 20%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
  .select-page {
    min-width: 270px !important;
    max-width: 400px;
    &.select-page-padding {
      .el-scrollbar__view.el-select-dropdown__list {
        padding-bottom: 34px !important;
      }
    }

  .select-pagination {
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #fff;
    width: 100%;
    text-align: center;
    .el-pager li {
      padding: 0 2px;
      font-size: 14px;
    }
    .el-pagination {
      padding: 6px 5px;
      padding-right: 8px;
      .el-pagination__total {
        margin-right: 4px;
      }
      button {
        padding: 0;
        .el-icon {
          padding-top: 3px;
        }
      }
      .btn-prev {
        padding-right: 2px;
      }
      .btn-next {
        padding-left: 2px;
      }
      .el-pagination__jump {
        margin-left: 4px;
      }
    }
  }
}
</style>
